import get from 'lodash.get';
import React, { Fragment } from 'react';
import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import t from '@jetshop/intl';
import { Pagination, PaginationBehaviour } from '@jetshop/ui/Pagination';
import { PaginationWrapper } from '@jetshop/ui/Pagination/Pagination';
import theme from '@jetshop/ui/utils/theme';
import styled from 'react-emotion';
import ProductGrid from '../CategoryPage/ProductGrid';
import Filter from '../CategoryPage/Filters';
import MaxWidth from '../Layout/MaxWidth';
import { Matches } from './SearchPage';
import SearchTerm from './SearchTerm';

const Container = styled(MaxWidth)``;

const StyledFilters = styled('div')`
  padding-bottom: 1rem;
`;

const StyledPaginationWrapper = styled(PaginationWrapper)`
  margin-bottom: 2rem;
  margin-top: 2rem;
  justify-content: center;
  > div {
    justify-content: center;
    ${theme('below.md')} {
      justify-content: space-between;
    }
  }
  ${theme('below.md')} {
    margin-bottom: 1rem;
  }
  ${theme('below.sm')} {
    margin-top: 1rem;
  }
  a,
  div div {
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    font-size: 12px;
    justify-content: center;
    ${theme('below.sm')} {
    }
  }
  a {
    color: ${theme('colors.white')};
    background: ${theme('colors.primary')};
    border: 1px solid ${theme('colors.primary')};
    padding: 0.5rem 0;
    transition: 0.2s ease;
    width: 130px;
    text-align: center;
    margin: 0 20px;
    font-weight: bold;
    ${theme('below.lg')} {
      width: 110px;
      padding: 8px 0;
      margin: 0;
      letter-spacing: 0.5px;
    }
    ${theme('below.sm')} {
    }
    :hover {
      background: ${theme('colors.white')};
      color: ${theme('colors.black')};
    }
  }
  a[data-disabled='true'] {
    background: ${theme('colors.white')};
    border-color: ${theme('colors.grey')};
    color: ${theme('colors.black')};
    cursor: not-allowed;
    opacity: 0.4;
    font-weight: normal;
    ${theme('below.sm')} {
    }
  }
`;

const SearchResults = ({ loading, ...props }) => {
  const { total, term } = props;
  const products = get(props, 'result', []);

  return (
    <PaginationContext.Consumer>
      {({ currentPage, goToPage, perPage }) => (
        <PaginationBehaviour total={props.total}>
          {paginatedProps => (
            <>
              <Container>
                <Matches>
                  {loading ? (
                    currentPage === 1 ? (
                      <div>
                        {t(`Loading search results for {term}…`, {
                          term
                        })}
                      </div>
                    ) : (
                      <div>
                        {t(`Loading page {currentPage}…`, {
                          currentPage
                        })}
                      </div>
                    )
                  ) : (
                    <div>
                      {t.rich(
                        '{total, plural, =1 {# item} other {# items}} matching for <Term />',
                        {
                          Term: () => (
                            <SearchTerm key="term">"{term}"</SearchTerm>
                          ),
                          total,
                          term
                        }
                      )}
                    </div>
                  )}
                </Matches>
              </Container>
              {(!loading || currentPage > 1) && (
                <Container>
                  {props.filters && (
                    <StyledFilters>
                      <Filter total={props.total} filters={props.filters} />
                    </StyledFilters>
                  )}
                  <PaginationBehaviour
                    currentPage={currentPage}
                    goToPage={goToPage}
                    perPage={perPage}
                    total={props.total}
                  >
                    {paginationProps => (
                      <Fragment>
                        <section>
                          <ProductGrid
                            listName="search"
                            products={products}
                            loading={loading}
                          />
                        </section>
                        <StyledPaginationWrapper>
                          <Pagination {...paginationProps} />
                        </StyledPaginationWrapper>
                      </Fragment>
                    )}
                  </PaginationBehaviour>
                </Container>
              )}
            </>
          )}
        </PaginationBehaviour>
      )}
    </PaginationContext.Consumer>
  );
};

export default SearchResults;
